import type { Source } from '../api/sources'

/** Map of internal source `name` -> `displayName`, built from the loaded sources list. */
export type SourceLabels = Map<string, string>

export function buildSourceLabels(sources: Pick<Source, 'name' | 'displayName'>[]): SourceLabels {
  return new Map(sources.map((s) => [s.name, s.displayName]))
}

/** Resolve an internal source name to its display name, falling back to the identifier itself. */
export function resolveSourceLabel(labels: SourceLabels, sourceName: string): string {
  return labels.get(sourceName) ?? sourceName
}
